<template>
  <div>
    <div class="d-flex justify-content-between">
      <span class="text-muted">{{ $t("message.employee") }}</span>
      <strong>{{ employeeName }}</strong>
    </div>
    <hr class="mt-1 mb-1" />
    <div class="d-flex justify-content-between">
      <span class="text-muted">{{ $t("message.service") }}</span>
      <strong>{{ serviceName }}</strong>
    </div>
    <hr class="mt-1 mb-1" />
    <div class="d-flex justify-content-between">
      <span class="text-muted">{{ $t("message.package") }}</span>
      <strong>{{ servicePackageName }}</strong>
    </div>
    <hr class="mt-1 mb-1" />
    <div class="d-flex justify-content-between">
      <span class="text-muted">{{ $t("message.date") }}</span>
      <strong>{{ date }}</strong>
    </div>
    <hr class="mt-1 mb-1" />
    <div class="d-flex justify-content-between">
      <span class="text-muted">{{ $t("message.time") }}</span>
      <strong>{{ time }}</strong>
    </div>
    <hr class="mt-1 mb-1" />
    <div class="d-flex justify-content-between">
      <span class="text-muted">{{ $t("message.total") }}</span>
      <strong>{{ total }}</strong>
    </div>
    <hr class="mt-1 mb-1" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  timestampToDateReadable,
  timestampToTimeReadable
} from "@/helpers/time";

export default {
  props: {
    booking: Object
  },
  computed: {
    ...mapGetters({
      employeeById: "employees/employeeById",
      serviceById: "services/serviceById"
    }),
    employeeName() {
      const { resourceId } = this.booking;
      const employee = this.employeeById(resourceId);
      if (!employee) return;
      return employee.name;
    },
    service() {
       const { serviceId } = this.booking;
      return this.serviceById(serviceId);
    },
    serviceName() {
      const { service } = this;
      if (!service) return;
      return service.name;
    },
    servicePackage() {
      const { service, booking } = this;
      if (!service) return;
      const { servicePackageId } = this.booking;
      if (!servicePackageId) return;
      return service.packages[servicePackageId];
    },
    servicePackageName() {
      const { servicePackage } = this;
      if (!servicePackage) return;
      return servicePackage.name; 
    },
    date() {
      const { start } = this.booking;
      return timestampToDateReadable(start);
    },
    time() {
      const { start, end } = this.booking;
      const startTime = timestampToTimeReadable(start);
      const endTime = timestampToTimeReadable(end);
      return `${startTime} - ${endTime}`;
    },
    total() {
      const { total } = this.booking;
      return `€${total}`;
    }
  }
};
</script>
